<template>
    <stream-item
        icon="monetization_on"
        line-type="dashed"
        class="deal-stream-item"
    >
        <div class="stream-item-deal-header">
            <div class="stream-item-deal-header-left">
                <a class="badge badge-secondary" :href="$root.buildUrl('deals/%s/edit', [data.id])">Deal #{{ data.id }}</a>
                <span :class="['badge', this.getDealStatusLabelColour(data)]">{{ data.life_cycle_status_label }}</span>
            </div>
            <stream-item-header
                class="stream-item-deal-header-right"
                :created-by="data.created_by"
                :created-at="data.created_at"
            />
        </div>

        <div class="stream-item-deal-content">
            <vehicle-description
                :instance="data.instance"
                show-image
            />
        </div>
    </stream-item>
</template>

<style lang="scss">
    .deal-stream-item {
        .stream-item-deal-header {
            color: #999;
            padding: 1rem 1rem .5rem;
            display: flex;
        }

        .stream-item-deal-content {
            padding: .5rem 1.5rem 1.75rem;
        }

        .stream-item-deal-header-right {
            padding: 0 .5rem 0 0;
            flex-grow: 1;
            text-align: right;
        }

        .stream-item-deal-header-left {
            padding-left: .5rem;
        }
    }
</style>

<script>
    import StreamItemHeader from './StreamItemHeader'
    import StreamItem from '../../elements/stream/StreamItem'
    import {DealLifeCycleStatuses} from "../../../classes/Api/Deal";

    const menuOptions = [
        {
            id: 'delete',
            icon: 'delete',
            label: 'Delete'
        }
    ]

    export default {
        components: { StreamItem, StreamItemHeader },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        methods: {
            getDealStatusLabelColour(deal) {
                switch (deal.life_cycle_status) {
                    case DealLifeCycleStatuses.DRAFT:
                    case DealLifeCycleStatuses.IN_PROGRESS:
                        return 'badge-warning';
                    case DealLifeCycleStatuses.COMPLETED:
                        return 'badge-success';
                    default:
                        return 'badge-danger';
                }
            }
        }
    }
</script>